import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'class-names';
import Swiper from 'swiper';
import { fetchItem } from '../../redux/cartUpsell/actions';
import { options } from '../../components/card-swiper';
import IconArrowLeft from '../icons/IconArrowLeft';
import IconArrowRight from '../icons/IconArrowRight';
import IconChevronLeft from '../icons/IconChevronLeft';
import IconChevronRight from '../icons/IconChevronRight';
import RecentItemFurniture from '../RecentItems/RecentItemFurniture';
import RecentItemHomeware from '../RecentItems/RecentItemHomeware';

class CartUpsellContent extends Component {
  constructor(props) {
    super(props);
    const { fetchItem, items } = props;

    items.forEach(({ handle, measurements, shippingRegion }, index) => fetchItem({
      handle, measurements, shippingRegion, sortIndex: index,
    }));

    this.swiperOuter = React.createRef();
  }

  componentDidMount() {
    options.navigation = {
      nextEl: '.upsell-items-next',
      prevEl: '.upsell-items-prev',
    };
    options.scrollbar = {
      el: '.upsell-items-swiper-scrollbar',
      hide: false,
    };

    const swiperOuterEl = this.swiperOuter.current;

    if (swiperOuterEl.classList.contains('card-swiper--v-center-nav')) {
      const repositionNav = () => {
        const slideImg = swiperOuterEl.querySelector('.card-swiper__slide img');

        if (slideImg) {
          const imgHeight = slideImg.clientHeight;
          const swiperArrows = swiperOuterEl.querySelectorAll('.swiper-arrow-prev, .swiper-arrow-next');

          swiperArrows.forEach((arrowEl) => {
            arrowEl.style.top = (imgHeight > 0) ? `${imgHeight / 2}px` : null;
          });
        }
      };

      options.on = {
        update: () => { setTimeout(repositionNav, 10); },
        resize: repositionNav,
      };
    }

    this.swiper = new Swiper('[data-react-component="CartUpsell"] .card-swiper', options);
  }

  componentDidUpdate(prevProps) {
    const { upsellItems } = this.props;
    if (prevProps.upsellItems !== upsellItems) {
      this.swiper.update();
    }
  }

  get filteredItems() {
    const { cartItems, upsellItems } = this.props;
    return upsellItems.filter((item) => !cartItems.some((cartItem) => String(cartItem.productId) === String(item.id)));
  }

  get sortedItems() {
    const { upsellItems } = this.props;
    return upsellItems.sort((item1, item2) => {
      if (item1.sortIndex < item2.sortIndex) {
        return -1;
      }
      if (item1.sortIndex > item2.sortIndex) {
        return 1;
      }
      return 0;
    });
  }

  render() {
    const { sectionTitle } = this.props;
    const { sortedItems } = this;
    return (
      <div className={classNames({ 'd-none': sortedItems.length === 0 })}>
        <div className="container text-center">
          <hr className="my-4 my-md-5" />
          {sectionTitle && (<h2 className="mb-4">{sectionTitle}</h2>)}
        </div>

        <div className="card-swiper__outer swiper-container-outer card-swiper--v-center-nav" ref={this.swiperOuter}>
          <div className="swiper-container card-swiper">
            <div className="card-swiper__wrapper swiper-wrapper">
              {
                sortedItems.map((product) => (
                  <div className="card-swiper__slide swiper-slide" key={`upsell-${product.id}`}>
                    {product.type === 'Furniture' && (<RecentItemFurniture product={product} />)}
                    {product.type !== 'Furniture' && (<RecentItemHomeware product={product} />)}
                  </div>
                ))
              }
            </div>
            <div className="swiper-scrollbar upsell-items-swiper-scrollbar d-md-none" />
          </div>
          <div className="swiper-chevron-prev d-md-none upsell-items-prev"><IconChevronLeft /></div>
          <div className="swiper-chevron-next d-md-none upsell-items-next"><IconChevronRight /></div>
          <div className="swiper-arrow-prev d-none d-md-block upsell-items-prev"><IconArrowLeft /></div>
          <div className="swiper-arrow-next d-none d-md-block upsell-items-next"><IconArrowRight /></div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchItem,
};

const mapStateToProps = (state) => ({
  cartItems: state.cart.items,
  upsellItems: state.cartUpsell.items,
});

CartUpsellContent.propTypes = {
  sectionTitle: PropTypes.string,
  cartItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  upsellItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchItem: PropTypes.func.isRequired,
};

CartUpsellContent.defaultProps = {
  sectionTitle: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(CartUpsellContent);
